import { render, staticRenderFns } from "./parentList.vue?vue&type=template&id=53c47fec&scoped=true&"
import script from "./parentList.vue?vue&type=script&lang=js&"
export * from "./parentList.vue?vue&type=script&lang=js&"
import style0 from "./parentList.vue?vue&type=style&index=0&id=53c47fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c47fec",
  null
  
)

export default component.exports